/**
 * Formats a time in seconds to a MM:SS string format
 * @param {number} timeInSeconds - The time in seconds to format
 * @returns {string} The formatted time string in MM:SS format
 */
export const formatTime = (timeInSeconds) => {
    
    if (typeof timeInSeconds !== 'number' || isNaN(timeInSeconds) || timeInSeconds < 0) {
        return "00:00";
    }
    
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
};
